<form
  [formGroup]="filterForm()!"
  (ngSubmit)="submit()"
  [ngStyle]="{
    'flex-flow': filterActionsPlacement() === 'start' ? 'row-reverse' : 'row'
  }">
  <div
    class="filter-inputs"
    [style]="'--numOfInputs:' + filters().length"
    [class.is-admin]="isAdmin">
    @for (filter of filters(); track filter) {
      <div
        class="filter-control"
        [ngClass]="{ 'checkbox-filter': filter.type == 'checkbox' }">
        @switch (filter.type) {
          @case ("text") {
            <input
              type="text"
              pInputText
              [placeholder]="filter.placeholder"
              [formControlName]="filter.controlName" />
          }
          @case ("dropdown") {
            <p-select
              [pTooltip]="filterForm()!.controls[filter.controlName].value ? filterForm()!.controls[filter.controlName].value[filter.optionLabel || 'name'] : filter.placeholder"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              appResetDropdownFilter
              appAdjustDropdownHeight
              appendTo="body"
              [formControlName]="filter.controlName"
              [showClear]="filter.clearable"
              [filter]="filter.enableFilters"
              [filterBy]="filter.optionLabel"
              [options]="filter.options"
              [optionLabel]="filter.optionLabel"
              [placeholder]="filter.placeholder"
              [virtualScroll]="filter.hasVirtualScroll"
              [virtualScrollItemSize]="36"
              [group]="filter.hasGroup">
              @if (filter.enableFilters) {
                <ng-template
                  pTemplate="filter"
                  let-options="options">
                  <div class="dropdown-search-box">
                    <div
                      class="p-inputgroup"
                      (click)="$event.stopPropagation()"
                      (keydown.enter)="$event.stopPropagation()">
                      <input
                        type="text"
                        pInputText
                        placeholder="Search"
                        ngModel
                        [ngModelOptions]="{ standalone: true }"
                        (keyup)="customFilterFunction($event, options)" />
                      <span class="p-inputgroup-search"><i class="icon-magnifying-glass"></i></span>
                    </div>
                  </div>
                </ng-template>
              }

              @if (filter.hasGroup) {
                <ng-template
                  let-group
                  #group>
                  <div class="flex align-items-center">
                    <span>{{ group.label }}</span>
                  </div>
                </ng-template>
              }

              <ng-template
                #item
                let-item
                let-selected="selected">
                <div class="w-full flex justify-content-between gap-spacing-xs align-items-center">
                  {{ item.label }}
                  @if (filterForm()!.controls[filter.controlName]?.value?.value == item.value) {
                    <span>
                      <i class="icon-check size-icon-md"></i>
                    </span>
                  }
                </div>
              </ng-template>
            </p-select>
          }
          @case ("cascadeSelect") {
            <p-cascadeSelect
              [pTooltip]="filterForm()!.controls[filter.controlName].value ? filterForm()!.controls[filter.controlName].value['label'] : filter.placeholder"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              [options]="filter.options ? filter.options : []"
              [formControlName]="filter.controlName"
              optionGroupLabel="label"
              [placeholder]="filter.placeholder"
              optionLabel="label"
              [optionGroupChildren]="['items']"
              appendTo="body" />
          }
          @case ("multiSelect") {
            <p-multiSelect
              [pTooltip]="filter | multiSelectTooltip: filterForm()!.controls[filter.controlName].value"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              appendTo="body"
              [formControlName]="filter.controlName"
              [options]="filter.options"
              [optionLabel]="filter.optionLabel"
              [placeholder]="filter.placeholder"
              [showClear]="true"
              [filter]="true"
              [filterBy]="filter.optionLabel"
              (onPanelHide)="clearMultiSelectFilter(multiSelectRef)"
              #multiSelectRef />
          }
          @case ("checkbox") {
            <p-checkbox
              [formControlName]="filter.controlName"
              [value]="true"
              [inputId]="filter.controlName" />
            <label [for]="filter.controlName">{{ filter.label }}</label>
          }
          @case ("time") {
            <p-datepicker
              appendTo="body"
              [formControlName]="filter.controlName"
              [placeholder]="filter.placeholder"
              [iconDisplay]="'input'"
              [showIcon]="false"
              [timeOnly]="true"
              hourFormat="12"
              [inputId]="filter.controlName">
            </p-datepicker>
          }
          @case ("date") {
            <p-datepicker
              appendTo="body"
              [formControlName]="filter.controlName"
              [placeholder]="filter.placeholder"
              [iconDisplay]="'input'"
              [showIcon]="false"
              icon="icon-calendar-blank"
              [inputId]="filter.controlName"></p-datepicker>
          }
        }

        @if (filter.type == "timeRange" && filter.rangeFilterReferences) {
          <div
            class="timeRange"
            [formGroupName]="filter.controlName">
            <p-datepicker
              appendTo="body"
              #fromTime
              [formControlName]="filter.rangeFilterReferences[0].controlName"
              [placeholder]="filter.rangeFilterReferences[0].placeholder"
              [iconDisplay]="'input'"
              [showIcon]="false"
              [timeOnly]="true"
              hourFormat="12"
              inputId="time-range-from"
              [className]="'time-range-from'">
            </p-datepicker>
            <p-datepicker
              appendTo="body"
              [minDate]="fromTime.value"
              [formControlName]="filter.rangeFilterReferences[1].controlName"
              [placeholder]="filter.rangeFilterReferences[1].placeholder"
              [iconDisplay]="'input'"
              [showIcon]="false"
              [timeOnly]="true"
              hourFormat="12"
              inputId="time-range-to"
              [className]="'time-range-from'">
            </p-datepicker>
          </div>
        }
        @if (filter.type == "dateRange" && filter.rangeFilterReferences) {
          <div
            class="dateRange"
            [formGroupName]="filter.controlName">
            <p-datepicker
              appendTo="body"
              #fromDate
              [formControlName]="filter.rangeFilterReferences[0].controlName"
              [placeholder]="filter.rangeFilterReferences[0].placeholder"
              [iconDisplay]="'input'"
              [showIcon]="true"
              inputId="date-range-from"
              icon="icon-calendar-blank"></p-datepicker>
            <p-datepicker
              appendTo="body"
              [minDate]="fromDate.value"
              [formControlName]="filter.rangeFilterReferences[1].controlName"
              [placeholder]="filter.rangeFilterReferences[1].placeholder"
              [iconDisplay]="'input'"
              [showIcon]="true"
              inputId="date-range-to"
              icon="icon-calendar-blank"></p-datepicker>
          </div>
        }
      </div>
    }
  </div>
  <div
    class="filter-actions"
    [ngClass]="{ 'flex-row': filters().length <= 5 }">
    <app-button
      [label]="clearButtonText()"
      (btnClick)="onClearFilters()"
      sizeClass="p-button-md"
      severity="secondary">
    </app-button>

    <div class="flex gap-spacing-xl align-items-center">
      <app-button
        class="cancel-btn"
        label="Cancel"
        (btnClick)="cancel.emit()"
        sizeClass="p-button-md"
        severity="secondary">
      </app-button>
      <app-button
        [label]="ApplyButtonText()"
        (btnClick)="submit()"
        [disabled]="isApplyButtonDisabled"
        sizeClass="p-button-md"
        severity="primary">
      </app-button>
    </div>
  </div>
</form>
